import { HTMLAttributes } from 'react'
import { useLenis } from 'lenis/react'

import { useScrollbar } from '@/contexts/lenis'

import { cn } from '@/lib/utils'

export type ScrollbarProps = HTMLAttributes<HTMLDivElement>

const Scrollbar = ({ className, ...props }: ScrollbarProps) => {
  const lenis = useLenis()
  const [track, thumb, needsScrollbar] = useScrollbar(lenis)

  return (
    <div
      className={cn(
        'z-scrollbar group fixed bottom-0 right-0 top-0 w-[1.2rem] touch:hidden',
        {
          visible: needsScrollbar,
          invisible: !needsScrollbar
        },
        className
      )}
      {...props}
    >
      <div ref={track} className="relative h-full w-full">
        <div
          ref={thumb}
          className={cn(
            'absolute left-0 top-0 w-full',
            'before:bg-rose01/0 before:absolute before:bottom-[.2rem] before:left-[.7rem] before:top-[.2rem] before:w-[.3rem] before:rounded-full'
          )}
        />
      </div>
    </div>
  )
}

export default Scrollbar
